<div class="dashboard-wrap">
    <div class="sidenav-wrap">
        <app-side-menu sideMenuType="type2"></app-side-menu>
    </div>
    <div class="page-wrap" *ngIf="!showLoading; else loading">
        <div class="title-action-wrap title-inline-wrap mb-3">
            <button type="button" class="btn btnIcon" routerLink="/validate-dash">
                <img src="./assets/images/arrow-left-short.svg" class="btn-icon" alt="backd"/>
            </button>

            <app-main-heading *ngIf="!uiPrivileges.profileDisplay" [title]="registrationData?.reg_id" customStyle="title title-medium no-border me-2"></app-main-heading>
            <app-main-heading *ngIf="uiPrivileges.profileDisplay" [title]="registrationData?.name" customStyle="title title-medium no-border me-2"></app-main-heading>
            <div class="tag-wrap">
                <span class="tag blue me-2" *ngIf="registrationData?.source">{{registrationData?.source}}</span>
                <span class="tag tag-outline font-500 blue me-2 text-uppercase" *ngIf="registrationData?.lang != '-'">{{registrationData?.lang}}</span>
                <span class="tag tag-outline font-500 blue me-2" *ngIf="registrationData?.answer_type.includes('VOICE') && registrationData?.answer_type != '-'">
                    <img src="./assets/images/mic.svg" alt="mic"/>
                </span>
                <span class="tag tag-outline font-500 me-2 p-0" *ngIf="registrationData?.answer_type.includes('IMAGE') && registrationData?.answer_type != '-'">
                    <img src="./assets/images/file-image.svg" alt="file-image"/>
                </span>
                <span class="tag tag-small tag-outline font-500 blue me-2" *ngIf="registrationData?.answer_type.includes('TEXT') && registrationData?.answer_type != '-'">TXT</span>
                <span class="tag red me-2" *ngIf="registrationData?.validation_status != '-'">{{registrationData?.validation_status}}</span>
            </div>
        </div>
        <section class="app-sec" *ngIf="uiPrivileges.profileDisplay">
            <div class="row row-xy-12 contest-dash">
                <div class="col-12 col-lg-2 col-md-6">
                    <div class="text-wrap">
                        <p class="caption mb-1">Mobile Number</p>
                        <p class="subtitle1">{{registrationData?.contact_number}}</p>
                    </div>
                </div>
                <div class="col-12 col-lg-3 col-md-6">
                    <div class="text-wrap">
                        <p class="caption  mb-1">Name</p>
                        <p class="subtitle1 text-capitalize">{{registrationData?.name}}</p>
                    </div>
                </div>
                <div class="col-12 col-lg-7 col-md-6">
                    <div class="text-wrap">
                        <p class="caption mb-1">Email ID</p>
                        <p class="subtitle1">{{registrationData?.email}}</p>
                    </div>
                </div>
                <div class="col-12 col-lg-2 col-md-6">
                    <div class="text-wrap">
                        <p class="caption mb-1">Age Range</p>
                        <p class="subtitle1">{{registrationData?.age_group}}</p>
                    </div>
                </div>
                <div class="col-12 col-lg-3 col-md-6">
                    <div class="text-wrap">
                        <p class="caption mb-1">Occupation</p>
                        <p class="subtitle1">{{registrationData?.occupation}}</p>
                    </div>
                </div>
                <div class="col-12 col-lg-2 col-md-6">
                    <div class="text-wrap">
                        <p class="caption mb-1">Pincode</p>
                        <p class="subtitle1">{{registrationData?.pincode}}</p>
                    </div>
                </div>
                <div class="col-12 col-lg-2 col-md-6">
                    <div class="text-wrap">
                        <p class="caption mb-1">State</p>
                        <p class="subtitle1">{{registrationData?.state}}</p>
                    </div>
                </div>
                <div class="col-12 col-lg-3 col-md-6">
                    <div class="text-wrap">
                        <p class="caption mb-1">City</p>
                        <p class="subtitle1">{{registrationData?.city}}</p>
                    </div>
                </div>
                <div class="col-12 col-md-12">
                    <div class="text-wrap">
                        <p class="caption mb-1">Where did you hear about us?</p>
                        <p class="subtitle1">{{registrationData?.where_did_you_hear_about_us}}</p>
                    </div>
                </div>
            </div>
        </section>

        <div class="image-carousel-wrap" [ngClass]="{'active': isShowImageSlider}">
            <div class="overlay-wrap active" (click)="toggleImageSlider()" ></div>
            <div class="image-slider-wrap">
                <ngx-slick-carousel class="carousel"
                    #slickModal="slick-carousel"
                    [config]="carouselConfig"
                >
                    <div ngxSlickItem class="slide" *ngFor="let item of slides">
                        <img [src]="item" alt="" width="100%">
                    </div>
                </ngx-slick-carousel>
            </div>
        </div>



        <form [formGroup]="validationContestForm">
          <section class="app-sec">
              <div class="row">
                  <div class="col-12">
                      <div class="loader-wrap">
                          <div class="loder-item" *ngIf="downloadLoader">
                              <div class="shimmertext">
                                  <span class="loader"></span>
                              </div>
                          </div>
                          <div class="accordion-wrap accordion-round-border">

                            <ng-container *ngFor="let questionItem of questionList; let i = index">
                              <div class="accord-title-wrap p-4">
                                <div class="text-wrap cursor-change">
                                  <img *ngIf="questionItem.qId == 1" src="./assets/images/lightbulb2.svg" alt="lightbulb2"/>
                                  <img *ngIf="questionItem.qId == 2" src="./assets/images/question-diamond.svg" alt="question-diamond"/>
                                  <img *ngIf="questionItem.qId == 3" src="./assets/images/mdi_rupee-1.svg" alt="mdi_rupee-1"/>
                                  <p class="subtitle1 blue-color font-400 font-poppins">{{questionItem.ques}}</p>
                                </div>
                                <div class="paddingRight-5">
                                    <img *ngIf="questionItem.type.includes('IMAGE')" src="./assets/images/material-symbols_doc.svg" alt="lightbulb2" style="margin-left: 4px; height: 26px;" />

                                    <img *ngIf="questionItem.type.includes('VOICE')" src="./assets/images/material-symbols_mic-outline_1.svg" alt="question-diamond" style="margin-left: 4px;" />

                                    <img *ngIf="questionItem.type.includes('TEXT')" src="./assets/images/Badge.svg" alt="mdi_rupee-1" style="margin-left: 4px;" />
                                  <!-- <img *ngIf="questionItem.type == 'IMAGE'" src="./assets/images/material-symbols_doc.svg" alt="lightbulb2"/>
                                  <img *ngIf="questionItem.type == 'VOICE'" src="./assets/images/material-symbols_mic-outline.svg" alt="question-diamond"/>
                                  <img *ngIf="questionItem.type == 'TEXT'" src="./assets/images/Badge.svg" alt="mdi_rupee-1"/> -->
                                </div>
                              </div>


                              <div class="accordion-body mb-4" [ngClass]="{'media-divider': i !== questionList.length - 1, 'px-4': i === questionList.length - 1}">
                                <div class="media-card-overflow mb-4" *ngIf="questionItem.type.includes('IMAGE') || questionItem.type.includes('VOICE')">
                                    <div class="media-card-wrap">
                                        <ng-container *ngIf="questionItem.type.includes('IMAGE')">
                                            <ng-container *ngFor="let urlItem of questionItem?.url; let url_i = index">
                                                <div class="media-card" *ngIf="containsAllowedExtension(urlItem)" (click)="containsAllowedExtension(urlItem) ? showImageSlider(url_i, questionItem?.url) : downloadDoc(urlItem)">
                                                    <div class="image-item">
                                                        <div class="img-wrap">
                                                            <img src="./assets/images/file-png.svg" alt="file"/>
                                                        </div>
                                                        <div class="download-icon-wrap" *ngIf="containsAllowedExtensionFiles(urlItem)">yy
                                                            <img src="./assets/images/download-icon.svg" alt="file"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container>

                                        <ng-container *ngIf="questionItem.type.includes('VOICE')">
                                          <ng-container *ngFor="let urlItem of questionItem?.url; let url_i = index">
                                              <div class="audio-wrap" *ngIf="containsAllowedExtensionSrcUrls(urlItem)">
                                                  <audio controls>
                                                      <source [src]="urlItem">
                                                  </audio>
                                              </div>
                                          </ng-container>


                                          <ng-container *ngIf="0">
                                              <div class="media-card media-border-blue"
                                                  *ngFor="let urlItem of questionItem?.url; let url_i = index"
                                                  (click)="audioPlay(urlItem,'1.8')"
                                              >
                                                  <div class="audio-item">
                                                      <div class="img-wrap">
                                                          <img [src]="(urlItem == currentAudioUrl && isPlaying) ? './assets/images/pause-fill.svg' : './assets/images/play-fill.svg'" alt="file"/>
                                                      </div>
                                                      <div class="text-wrap mt-3">
                                                          <p class="subtitle2 blue-color font-400"></p>
                                                      </div>
                                                      <div class="wave-wrap">
                                                          <div class='sound-wave' [ngClass]="{'play': (urlItem == currentAudioUrl && isPlaying)}">
                                                              <div class='bar'  *ngFor="let item of [].constructor(40)" [ngStyle]="{'animation-duration': getRandomNumber()+'s'}"></div>
                                                          </div>

                                                      </div>
                                                  </div>
                                              </div>
                                          </ng-container>
                                      </ng-container>
                                    </div>
                                </div>

                                <div class="text-wrap mb-4" *ngIf="questionItem.ans">
                                  <div class="desc-wrap">
                                      <p class="subtitle1 text-color font-400 word-break-word">{{questionItem.ans}}</p>
                                  </div>
                                </div>

                                <ng-container>
                                  <!-- --- View & Language Not English ---- -->
                                    <div class="label-desc-wrap text-wrap mt-4 mb-4"  *ngIf="persentMode == 0 && registrationData?.lang !== 'en'">
                                        <div *ngIf="questionItem.type.includes('VOICE') || questionItem.type.includes('IMAGE')">
                                          <div class="label-wrap mb-2">
                                            <p class="subtitle1 text-grey-color font-400">Transcription</p>
                                          </div>
                                          <ng-container>
                                              <div class="desc-wrap mb-2">
                                                  <p class="subtitle1 text-color font-400 word-break-word">{{questionItem.transcripted_text}}</p>
                                              </div>
                                          </ng-container>
                                        </div>
                                    </div>
                                    <!-- --- View & Language Is English ---- -->
                                    <!-- <div class="label-desc-wrap text-wrap mt-4 mb-4"  *ngIf="persentMode == 0 && registrationData?.lang === 'en'">
                                      <div *ngIf="questionItem.type.includes('VOICE') || questionItem.type.includes('IMAGE')">
                                        <div class="label-wrap mb-2">
                                          <p class="subtitle1 text-grey-color font-400">Transcription2</p>
                                        </div>
                                        <ng-container>
                                            <div class="desc-wrap mb-2">
                                                <p class="subtitle1 text-color font-400 word-break-word">{{questionItem.transcripted_text}}</p>
                                            </div>
                                        </ng-container>
                                      </div>
                                    </div> -->
                                    <!-- --- Edit & Language Not English  ---- -->
                                    <div class="form-wrap mb-4" *ngIf="persentMode == 1 && registrationData?.lang !== 'en'">
                                      <div class="form-row" *ngIf="questionItem.type.includes('VOICE') || questionItem.type.includes('IMAGE')">
                                          <div class="text-wrap mb-2">
                                              <p class="subtitle1 text-grey-color font-400">Transcription</p>
                                          </div>
                                          <div class="input-group inputGroup mt-0">
                                              <textarea
                                                  readonly
                                                  rows="8"
                                                  placeholder="Transcription will be coming here"
                                                  class="inputBox regTextarea form-control form-control-height desc-wrap"
                                                  style="cursor: default;"
                                              >{{ questionItem.transcripted_text }}</textarea>
                                          </div>
                                      </div>
                                    </div>
                                    <div class="form-wrap mb-4" *ngIf="persentMode == 1 && registrationData?.lang !== 'en'">
                                        <div class="form-row" *ngIf="questionItem.type.includes('VOICE') || questionItem.type.includes('IMAGE') || questionItem.type.includes('TEXT')">
                                            <div class="text-wrap mb-2">
                                                <p class="subtitle1 text-grey-color font-400">Translation</p>
                                            </div>
                                            <div class="input-group inputGroup mt-0">
                                                <textarea
                                                    [id]="'translation_'+questionItem.aId"
                                                    [name]="'translation_'+questionItem.aId"
                                                    [formControlName]="'translation_'+questionItem.aId"
                                                    rows="8"
                                                    placeholder="Translation will be coming here"
                                                    class="inputBox regTextarea form-control form-control-height desc-wrap"
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div><div class="form-wrap mb-4" *ngIf="persentMode == 1 && registrationData?.lang === 'en'">
                                        <div class="form-row" *ngIf="questionItem.type.includes('VOICE') || questionItem.type.includes('IMAGE')">
                                            <div class="text-wrap mb-2">
                                                <p class="subtitle1 text-grey-color font-400">Translation</p>
                                            </div>
                                            <div class="input-group inputGroup mt-0">
                                                <textarea
                                                    [id]="'translation_'+questionItem.aId"
                                                    [name]="'translation_'+questionItem.aId"
                                                    [formControlName]="'translation_'+questionItem.aId"
                                                    rows="8"
                                                    placeholder="Translation will be coming here"
                                                    class="inputBox regTextarea form-control form-control-height desc-wrap"
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="form-wrap mb-4" *ngIf="persentMode == 1 && questionItem.type.includes('IMAGE')">
                                        <div class="form-row">
                                            <div class="text-wrap mb-2">
                                                <p class="subtitle1 text-grey-color font-400">Translation3</p>
                                            </div>
                                            <div class="input-group inputGroup mt-0">
                                                <textarea
                                                    [id]="'translation_'+questionItem.aId"
                                                    [name]="'translation_'+questionItem.aId"
                                                    [formControlName]="'translation_'+questionItem.aId"
                                                    rows="8"
                                                    placeholder="Translation will be coming here"
                                                    class="inputBox regTextarea form-control form-control-height desc-wrap"
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div> -->
                                    <ng-container>
                                        <div class="label-desc-wrap text-wrap mt-4 mb-4" *ngIf="persentMode == 0 && registrationData?.lang !== 'en'">
                                            <div *ngIf="questionItem.type.includes('IMAGE') || questionItem.type.includes('VOICE') || questionItem.type.includes('TEXT')">
                                              <div class="label-wrap mb-2">
                                                  <p class="subtitle1 text-grey-color font-40">Translation</p>
                                              </div>
                                              <div class="desc-wrap">
                                                  <p class="subtitle1 text-color font-400">{{questionItem.translated_text}}</p>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="label-desc-wrap text-wrap mt-4 mb-4" *ngIf="persentMode == 0 && registrationData?.lang === 'en'">
                                            <div *ngIf="questionItem.type.includes('IMAGE') || questionItem.type.includes('VOICE')">
                                              <div class="label-wrap mb-2">
                                                  <p class="subtitle1 text-grey-color font-40">Translation</p>
                                              </div>
                                              <div class="desc-wrap">
                                                  <p class="subtitle1 text-color font-400">{{questionItem.translated_text}}</p>
                                              </div>
                                            </div>
                                          </div>
                                    </ng-container>
                                </ng-container>
                              </div>

                            </ng-container>
                          </div>

                      </div>
                  </div>
              </div>
          </section>
          <section class="app-sec" *ngIf="persentMode == 1">
              <div class="row">
                  <div class="col-12">
                      <div class="form-wrap">
                          <div class="form-row">
                              <h3 class="form-title">Remarks*</h3>
                              <div class="input-group inputGroup mt-0">
                                  <textarea
                                      id="remarks"
                                      formControlName="remarks"
                                      rows="8"
                                      placeholder="Remarks will be coming here"
                                      class="inputBox regTextarea form-control form-control-height"
                                  ></textarea>
                                  <!-- <label for="addreg" class="inputLabel">Enter remarks.....</label> -->
                              </div>
                          </div>
                          <div class="row mt-5">
                              <div class="col-12 col-md-3">
                                  <div class="form-row">
                                      <div class="input-group inputGroup">
                                          <mat-form-field class="w-100 mat-input-group form-select-control form-control-bold form-control-hightlight" appearance="outline" id="statusId">
                                              <mat-label class="matLabel">Select Status</mat-label>
                                              <mat-select formControlName="statusId">
                                                  <mat-option [value]="item.id" *ngFor="let item of validationStatus">{{item.name}}</mat-option>
                                              </mat-select>
                                          </mat-form-field>
                                      </div>
                                  </div>
                              </div>
                              <div class="col-12 col-md-3">
                                  <div class="form-row d-flex align-items-end h-100">
                                      <button type="button"
                                          class="btn btnTheme blue w-100"
                                          (click)="onSubmitConfirmation()"
                                          [disabled]="!this.validationContestForm.valid"
                                      >
                                          Submit
                                      </button>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
      </form>

        <form class="d-none" [formGroup]="validationContestForm">
            <section class="app-sec">
                <div class="row">
                    <div class="col-12">
                        <div class="loader-wrap">
                            <div class="loder-item" *ngIf="downloadLoader">
                                <div class="shimmertext">
                                    <span class="loader"></span>
                                </div>
                            </div>
                            <div class="accordion-wrap accordion-round-border">
                                <mat-accordion>

                                    <ng-container *ngFor="let questionItem of questionList; let i = index">
                                        <mat-expansion-panel>
                                            <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                        <div class="accord-title-wrap">
                                                            <div class="text-wrap">
                                                                <img *ngIf="questionItem.qId == 1" src="./assets/images/lightbulb2.svg" alt="lightbulb2"/>
                                                                <img *ngIf="questionItem.qId == 2" src="./assets/images/question-diamond.svg" alt="question-diamond"/>
                                                                <img *ngIf="questionItem.qId == 3" src="./assets/images/mdi_rupee-1.svg" alt="mdi_rupee-1"/>
                                                                <p class="body1 font-400 font-poppins">{{questionItem.ques}}</p>
                                                            </div>
                                                            <div class="action-wrap" *ngIf="questionItem.type.includes('VOICE') && questionItem.type != '-'">
                                                                <span class="action-icon"><img src="./assets/images/mic.svg" alt="mic"/></span>
                                                            </div>
                                                        </div>
                                                </mat-panel-title>
                                            </mat-expansion-panel-header>

                                            <div class="accordion-body">

                                                <div class="media-card-overflow mb-4" *ngIf="questionItem.type.includes('IMAGE') || questionItem.type.includes('VOICE')">
                                                    <div class="media-card-wrap">
                                                        <ng-container *ngIf="questionItem.type.includes('IMAGE')">
                                                            <ng-container *ngFor="let urlItem of questionItem?.url; let url_i = index">
                                                                <div class="media-card" (click)="containsAllowedExtension(urlItem) ? showImageSlider(url_i, questionItem?.url) : downloadDoc(urlItem)">
                                                                    <div class="image-item">
                                                                        <div class="img-wrap">
                                                                            <img src="./assets/images/file-png.svg" alt="file"/>
                                                                        </div>
                                                                        <div class="download-icon-wrap" *ngIf="!containsAllowedExtension(urlItem)">
                                                                            <img src="./assets/images/download-icon.svg" alt="file"/>
                                                                        </div>
                                                                        <!-- <div class="text-wrap mt-3">
                                                                            <p class="subtitle2 grey-color font-400">image.tsts</p>
                                                                        </div> -->
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                        </ng-container>

                                                        <ng-container *ngIf="questionItem.type.includes('VOICE')">

                                                            <ng-container *ngFor="let urlItem of questionItem?.url; let url_i = index">
                                                                <div class="audio-wrap">
                                                                    <audio controls>
                                                                        <source [src]="urlItem">
                                                                    </audio>
                                                                </div>
                                                            </ng-container>


                                                            <ng-container *ngIf="0">
                                                                <div class="media-card media-border-blue"
                                                                    *ngFor="let urlItem of questionItem?.url; let url_i = index"
                                                                    (click)="audioPlay(urlItem,'1.8')"
                                                                >
                                                                    <div class="audio-item">
                                                                        <div class="img-wrap">
                                                                            <img [src]="(urlItem == currentAudioUrl && isPlaying) ? './assets/images/pause-fill.svg' : './assets/images/play-fill.svg'" alt="file"/>
                                                                        </div>
                                                                        <div class="text-wrap mt-3">
                                                                            <p class="subtitle2 blue-color font-400"></p>
                                                                        </div>
                                                                        <div class="wave-wrap">
                                                                            <div class='sound-wave' [ngClass]="{'play': (urlItem == currentAudioUrl && isPlaying)}">
                                                                                <div class='bar'  *ngFor="let item of [].constructor(40)" [ngStyle]="{'animation-duration': getRandomNumber()+'s'}"></div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ng-container>

                                                        </ng-container>

                                                    </div>
                                                </div>


                                                <div class="text-wrap mb-4 media-divider" *ngIf="questionItem.ans">
                                                    <div class="desc-wrap">
                                                        <p class="body2 text-color font-400 word-break-word">{{questionItem.ans}}</p>
                                                    </div>
                                                </div>

                                                <ng-container>
                                                    <div class="label-desc-wrap text-wrap mt-4 mb-4" *ngIf="questionItem.transcripted_text.length > 0">
                                                        <div class="label-wrap mb-2">
                                                            <p class="body1 text-color font-400">Transcription</p>
                                                        </div>
                                                        <ng-container *ngFor="let textItem of questionItem.transcripted_text">
                                                            <div class="desc-wrap mb-2">
                                                                <p class="body2 text-color font-400 word-break-word">{{textItem}}</p>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                    <div class="form-wrap mb-4" *ngIf="persentMode == 1">
                                                        <div class="form-row">
                                                            <div class="text-wrap mb-2">
                                                                <p class="body1 text-color font-400">Translation</p>
                                                            </div>
                                                            <div class="input-group inputGroup mt-0">
                                                                <textarea
                                                                    [id]="'translation_'+questionItem.aId"
                                                                    [name]="'translation_'+questionItem.aId"
                                                                    [formControlName]="'translation_'+questionItem.aId"
                                                                    rows="8"
                                                                    placeholder="Translation will be coming here"
                                                                    class="inputBox regTextarea form-control form-control-height form-control-hightlight"
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <ng-container *ngIf="questionItem.translated_text.length > 0">
                                                        <div class="label-desc-wrap text-wrap mt-4 mb-4" *ngIf="persentMode == 0">
                                                            <div class="label-wrap mb-2">
                                                                <p class="body1 text-color font-400">Translation</p>
                                                            </div>
                                                            <div class="desc-wrap">
                                                                <p class="body2 text-color font-400">{{questionItem.translated_text}}</p>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </div>
                                        </mat-expansion-panel>
                                    </ng-container>
                                  </mat-accordion>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <section class="app-sec" *ngIf="persentMode == 1">
                <div class="row">
                    <div class="col-12">
                        <div class="form-wrap">
                            <div class="form-row">
                                <h3 class="form-title">Remarks*</h3>
                                <div class="input-group inputGroup mt-0">
                                    <textarea
                                        id="remarks"
                                        formControlName="remarks"
                                        rows="8"
                                        placeholder="Remarks will be coming here"
                                        class="inputBox regTextarea form-control form-control-height"
                                    ></textarea>
                                    <!-- <label for="addreg" class="inputLabel">Enter remarks.....</label> -->
                                </div>
                            </div>
                            <div class="row mt-5">
                                <div class="col-12 col-md-3">
                                    <div class="form-row">
                                        <div class="input-group inputGroup">
                                            <mat-form-field class="w-100 mat-input-group form-select-control form-control-bold form-control-hightlight" appearance="outline" id="statusId">
                                                <mat-label class="matLabel">Select Status</mat-label>
                                                <mat-select formControlName="statusId">
                                                    <mat-option [value]="item.id" *ngFor="let item of validationStatus">{{item.name}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-3">
                                    <div class="form-row d-flex align-items-end h-100">
                                        <button type="button"
                                            class="btn btnTheme blue w-100"
                                            (click)="onSubmitConfirmation()"
                                            [disabled]="!this.validationContestForm.valid"
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </form>




        <section class="app-sec" *ngIf="persentMode == 1">
            <div class="row">
                <div class="col-12">
                    <div class="overlay-wrap"></div>
                    <div class="card-wrap registartion-list-wrap">
                        <div class="card-header-wrap card-header-action">
                            <div class="text-wrap">
                                <h3 class="font-circular-std font-500 text-color">Other Submissions</h3>
                            </div>
                        </div>
                        <div class="card-edge-wrap">
                            <div class="loder-item"  *ngIf="showRegistrationLoading">
                                <div class="shimmertext">
                                    <span class="loader"></span>
                                </div>
                            </div>
                            <div class="table-wrap table-overflow table-listing-data registration-table-wrap">
                                <table mat-table [dataSource]="registrationListData">
                                    <ng-container matColumnDef="reg_id">
                                        <th mat-header-cell *matHeaderCellDef> Registration  ID </th>
                                        <td mat-cell *matCellDef="let element"> {{element.reg_id}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="contact_number">
                                        <th mat-header-cell *matHeaderCellDef> Mobile Number </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span>{{element.contact_number}}</span>
                                            <div class="tag-wrap">
                                                <span class="tag tag-small blue me-2" *ngIf="element.status != '-'">{{element.status}}</span>
                                                <span class="tag tag-small red" *ngIf="element.user_cat != '-'">{{element.user_cat}}</span>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="name"  *ngIf="uiPrivileges.nameInContestListing">
                                        <th mat-header-cell *matHeaderCellDef> Name </th>
                                        <td mat-cell *matCellDef="let element" class="text-capitalize"> {{element.name}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="source">
                                        <th mat-header-cell *matHeaderCellDef> Source </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span>{{element.source}}</span>
                                            <div class="tag-wrap source-tag">
                                                <span class="tag tag-small tag-outline font-500 blue me-2 text-uppercase" *ngIf="element.language != '-'">{{element.language}}</span>
                                                <span class="tag tag-small tag-outline font-500 blue me-2" *ngIf="element.answer_type.includes('VOICE') && element.answer_type != '-'">
                                                    <img src="./assets/images/mic.svg" alt="mic"/>
                                                </span>
                                                <span class="tag tag-small tag-outline font-500 me-2 px-0" *ngIf="element.answer_type.includes('IMAGE') && element.answer_type != '-'">
                                                    <img src="./assets/images/file-image.svg" alt="file-image"/>
                                                </span>
                                                <span class="tag tag-small tag-outline font-500 blue me-2" *ngIf="element.answer_type.includes('TEXT') && element.answer_type != '-'">TXT</span>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="validation_status">
                                        <th mat-header-cell *matHeaderCellDef> Validation Status </th>
                                        <td mat-cell *matCellDef="let element"> {{element.validation_status}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="submitted_dt">
                                        <th mat-header-cell *matHeaderCellDef> Submitted Date </th>
                                        <td mat-cell *matCellDef="let element" class="text-nowrap"> {{convertDate(element.submitted_dt)}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef> Action </th>
                                        <td mat-cell *matCellDef="let element">
                                            <div class="btn-wrap">
                                                <button type="button" class="btn btnIcon" [routerLink]="['/validate-dash-details/', element?.id ,1]" *ngIf="element?.isEditEnabled">
                                                    <img src="./assets/images/pencil-alt.svg" class="btn-icon" alt="pencil-alt"/>
                                                </button>
                                                <button type="button" class="btn btnIcon" [routerLink]="['/validate-dash-details/', element?.id ,0]">
                                                    <img src="./assets/images/eye.svg" class="btn-icon" alt="eye"/>
                                                </button>
                                            </div>
                                        </td>
                                    </ng-container>

                                    <tr class="mat-row" *matNoDataRow>
                                        <td class="mat-cell" colspan="7">
                                            <div class="text-wrap p-3">
                                                <p class="subtitle1 black-color">No result found</p>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr mat-header-row *matHeaderRowDef="registrationListColumn; sticky: true"></tr>
                                    <tr mat-row *matRowDef="let row; columns: registrationListColumn;"></tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>

<ng-template #loading>
    <div class="shimmertext">
        <span class="loader"></span>
    </div>
</ng-template>

<!-- <app-be-a-part [becomeASellerNowScreenData]="titleText" [becomeASellerNowButtonScreenData]="BtnText"></app-be-a-part> -->
